import { Stack } from '@axo/ui-core/components/layout/item';
import styles from '../../../loan.module.scss';
import { EmploymentFormGroup } from '../../shared/EmploymentFormGroup';
import { CoApplicantDetails } from './CoApplicantDetails';
import { CoApplicantHousing } from './CoApplicantHousing';

export const CoAppFormGroup = () => {
  return (
    <div className={styles.inputGroup} data-grey={true}>
      <Stack gap="3xs">
        <CoApplicantDetails />
        <CoApplicantHousing />
        <EmploymentFormGroup applicant="CoApplicant" />
      </Stack>
    </div>
  );
};
